export function crmRefreshInterval(
  path: string,
  data: unknown,
): number | false {
  if (path === "crm/chat:listMessages" || path === "crm/supportChat:messages" || path === "crm/supportChat:inbox") return 5_000;
  if (
    [
      "crm/siteTheme:getPublic",
      "crm/chat:listThreads",
      "crm/chat:totalUnread",
      "crm/stats:workspaceOverview",
      "crm/dashboardPreferences:workload",
      "crm/consulting:syncStatus",
      "crm/stats:overview",
      "crm/stats:accountBalance",
      "crm/finance:overview",
      "crm/agencyRevenue:workspace",
      "crm/finance:walletBalances",
      "crm/finance:listWalletTransactions",
      "crm/copyWorkflow:myWallet",
      "crm/finance:myPayouts",
      "crm/consulting:walletReconciliation",
      "crm/finance:listPayoutRequests",
      "crm/calendar:deadlinesInRange",
      "crm/calendar:upcomingDeadlines",
      "crm/events:listInRange",
      "crm/events:listUpcoming",
      "crm/contacts:digitalAssistantWorkspace",
      "crm/legacyOperations:overview",
    ].includes(path)
  )
    return 30_000;
  if (
    [
      "crm/notifications:unreadByPath",
      "crm/notifications:unreadCount",
      "crm/notifications:listMine",
      "contact:listAdmin",
    ].includes(path)
  )
    return 30_000;
  if (path === "contact:listReplies") {
    const pending =
      Array.isArray(data) &&
      data.some(
        (item) => item?.status === "queued" || item?.status === "sending",
      );
    return pending ? 5_000 : 30_000;
  }
  return false;
}
